<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>
<div mat-dialog-content>
    <p class="mat-body-1">{{message}}</p>
</div>
<div mat-dialog-actions align="center">
    <form [formGroup]="creditcardConfirmation">
        <mat-card>
            <mat-form-field>
                <input type="text" matInput placeholder="Request Number" formControlName="requestNumber" readonly>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput
                    placeholder="{{type === 'project' ? 'Project Name' : type === 'event' ? 'Event Name' : 'Request Name'}}"
                    formControlName="requestName" readonly>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput maxlength="20" required placeholder="Enter Confirmation Number"
                    formControlName="confirmationNoCC">
            </mat-form-field>
        </mat-card>
    </form>
    <div align="center" style="margin-top: 15px;">
        <button mat-raised-button (click)="onNoClick()" color="warn">{{isFoundationTrustee? 'Skip': 'Cancel'}}</button>
        <button mat-raised-button color="primary" [disabled]="creditcardConfirmation.invalid"
            (click)="onSave()">{{isFoundationTrustee? 'Save and Next': 'Save'}}</button>
    </div>
</div>